import { useContext } from 'react'
import { ModalMessageContext } from '../context/ModalMessageContext'

export const useModalMessage = () => useContext(ModalMessageContext)
